import { Button, Dropdown, Modal, Table, ButtonGroup, Form } from "react-bootstrap";
import { useEffect, useState, useMemo } from "react";
import { DeleteRequest, GetRequest, PostRequest, PutRequest } from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEllipsisVertical, faEye, faTrash, faEnvelope, faPaperPlane, faFilter, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import DeleteModal from "../DeleteModal";
import { toast } from "sonner";
import { getAllCities, getAllStates, getCountries } from "../../Utils/hooks/location";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { MyEditor } from "../../Utils/helpers/MyEditor";
import { baseURL } from "../../Utils/constants/constant";
import { Filter } from "../../CommonComponents/Filter";
import useCommonData from "../../Utils/actions/advanceFilteringAction";
import Select from "react-select";
import { customStyles, fetchTemporaryFilterData } from "../../Utils/helpers/commonhelper";
import { AuthorizationCard } from "../../CommonComponents/AuthorizationCard";
import { Pagination } from "../../CommonComponents/Pagination";
import { useGlobalState } from "../../Utils/hooks/useFilterQueryValue";

const FILTER_CARD_LIMIT = 15;
const LIST_LIMIT_OPTIONS = [25, 100, 200, 300];

const industryOptions = [
  { value: "Technology", label: "Technology" }, { value: "Healthcare", label: "Healthcare" },
  { value: "Finance", label: "Finance" }, { value: "Education", label: "Education" },
  { value: "Manufacturing", label: "Manufacturing" }, { value: "Retail", label: "Retail" }
];

const businessTypeOptions = [
  { value: "Sole Proprietorship", label: "Sole Proprietorship" },
  { value: "Limited Liability Partnership(LLP)", label: "Limited Liability Partnership(LLP)" },
  { value: "Private Limited Company", label: "Private Limited Company" }
];

const employeeSizeOptions = [
  { value: '1-10', label: '1-10' },
  { value: '11-50', label: '11-50' },
  { value: '51-200', label: '51-200' },
  { value: '1001+', label: '1001+' }
];

const emailSchema = z.object({
  module_name: z.string().min(1, "Campaign name is required"),
  subject: z.string().min(1, "Subject is required"),
  body: z.string().min(1, "Body content cannot be empty"),
  image: z.any().optional(),
});

export const EmailCampaingning = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [campaignName, setCampaignName] = useState("");
  const [updateCampaignId, setUpdateCampaignId] = useState(null);
  const [description, setDescription] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("leads");
  const [listTableData, setListTableData] = useState([]);
  const [tabData, setTabData] = useState([]);
  const [refetchTabData, setRefetchTabData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeCardId, setActiveCardId] = useState(null);
  const [filterCardOffset, setFilterCardOffset] = useState(0);
  const [filterPageCount, setFilterPageCount] = useState(0);
  const [listLimit, setListLimit] = useState(25);
  const [listOffset, setListOffset] = useState(0);
  const [listTotalCount, setListTotalCount] = useState(0);
  const [listLoading, setListLoading] = useState(false);
  const navigate = useNavigate();

  const [customer, setCustomer] = useLocalStorageState("customer");
  const [PERMISSION, _] = useLocalStorageState('permission');

  const customerId = customer?.customer_details?.customer_id;
  const loginUserId = customer?.customer_details?.id;
  const userType = customer?.customer_details?.user_type;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;

  const getFilterCardsEndpoint = (tab) => {
    const qs = `?offset=${filterCardOffset}&limit=${FILTER_CARD_LIMIT}&search=`;
    if (tab === "leads") return `common/fetchFilterCard/${customerId}/leads/${loginUserId}${qs}`;
    if (tab === "contact") return `contacts/fetchFilterCards/${customerId}/${loginUserId}${qs}`;
    if (tab === "company") return `company/fetchFilterCards/${customerId}/${loginUserId}${qs}`;
    return "";
  };

  const getFilterRenameModuleName = (tab) => {
    if (tab === "leads") return "leads";
    if (tab === "contact") return "contact";
    if (tab === "company") return "company";
    return "leads";
  };

  const getDeleteFilterEndpoint = (tab, filterId) => {
    if (tab === "leads") return `common/deleteFilter/${filterId}`;
    if (tab === "contact") return `contacts/deleteFilter/${filterId}`;
    if (tab === "company") return `company/deleteFilter/${filterId}`;
    return "";
  };

  const getApplyFilterModuleName = (tab) => {
    if (tab === "leads") return "lead";
    if (tab === "contact") return "contacts";
    if (tab === "company") return "company";
    return "lead";
  };

  const EMAIL_CAMPAIGN_FILTER_QUERY_KEY = "emailCampaignApplyFilterQueryValues";
  const EMAIL_CAMPAIGN_FILTER_PARAMS_KEY = "emailCampaignFilterDataParams";

  const headers = useMemo(() => ({
    authentication: rf,
    Authorization: token,
  }), [rf, token]);

  const extras = { customer, setCustomer, rf, navigate };

  const emailCampaignGrant = PERMISSION?.campaigning?.email_campaigning;

  const [parsedFilterData, setParsedFilterData] = useState(null);
  const [filterDropdown, setFilterDropdown] = useState(false);
  const [filterStates, setFilterState] = useState(null);
  const [tempFilterData, setTempFilterData] = useState(null);
  const [tempFilterDataLoading, setTempFilterDataLoading] = useState(false);
  const [emailCampaignFilterDataParams, setEmailCampaignFilterDataParams] = useGlobalState(
    EMAIL_CAMPAIGN_FILTER_PARAMS_KEY,
    { currAdvFilter: null, applyFilterData: {} }
  );
  const [currAdvFilter, setCurrAdvFilter] = useState(
    emailCampaignFilterDataParams?.currAdvFilter || null
  );
  const [emailCampaignFilterValues] = useGlobalState(EMAIL_CAMPAIGN_FILTER_QUERY_KEY, {});
  const [country, setCountries] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allCity, setAllCity] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [pipeline, setPipelines] = useState(null);
  const [pipelineStages, setPipelineStages] = useState(null);
  const [selectedPipelineId, setSelectedPipelineId] = useState(null);

  const pipelineOptions = pipeline !== null && pipeline?.map((el) => ({
    value: el.id,
    label: el.pipeline_name,
  }));

  const { leadOwner, lead_source, company, contacts } = useCommonData({
    leadOwner: true,
    leadSource: true,
    companies: true,
    contacts: true,
  });

  const [currModule, setCurrModule] = useState("leads");
  const [currFilterEndpoint, setCurrFilterEndpoint] = useState("common/filterQuery");
  const [currFilterApplyQuery, setCurrFilterApplyQuery] = useState("lead/applyFilter");

  const isApplyFilterActive =
    currAdvFilter === "apply" && emailCampaignFilterValues?.filter_values?.length > 0;

  const dataToDisplay = isApplyFilterActive
    ? tempFilterData?.data || []
    : listTableData;

  const activeListTotalCount = isApplyFilterActive
    ? tempFilterData?.total_count ?? 0
    : listTotalCount;

  const startItemIndex = activeListTotalCount > 0 ? listOffset + 1 : 0;
  const endItemIndex = Math.min(listOffset + listLimit, activeListTotalCount);

  const applyFilterDataParams = {
    filterValues: emailCampaignFilterValues,
    selectedPipelineId,
    currView: "list",
    offset: listOffset,
    limit: listLimit,
    module_name: getApplyFilterModuleName(selectedTab),
    customerId,
    loginUserId,
    userType,
    headers,
    extras,
    setTempFilterData,
    setLoading: setTempFilterDataLoading,
    setFilterState,
    setFilterDropdown,
  };

  useEffect(() => {
    setEmailCampaignFilterDataParams({
      currAdvFilter,
      applyFilterData: {
        ...applyFilterDataParams,
        filterValues: emailCampaignFilterValues,
        selectedPipelineId,
        currView: "list",
        offset: listOffset,
        limit: listLimit,
        module_name: getApplyFilterModuleName(selectedTab),
      },
    });
  }, [
    currAdvFilter,
    emailCampaignFilterValues,
    listOffset,
    listLimit,
    selectedPipelineId,
    selectedTab,
  ]);

  useEffect(() => {
    if (selectedTab === "leads" && !selectedPipelineId) return;
    if (
      currAdvFilter === "apply" &&
      emailCampaignFilterValues?.filter_values?.length > 0
    ) {
      fetchTemporaryFilterData(emailCampaignFilterDataParams?.applyFilterData);
    }
  }, [emailCampaignFilterDataParams?.applyFilterData]);

  const dropdownOptions = useMemo(() => {
    if (selectedTab === "contact") {
      return [
        { value: "first_name", label: "First Name" },
        { value: "last_name", label: "Last Name" },
        { value: "email", label: "Email" },
        { value: "phone", label: "Phone" },
        { value: "owner_id", label: "Owner", option: leadOwner },
        { value: "company_id", label: "Company Name", option: company },
        { value: "contact_id", label: "Contact", option: contacts },
        { value: "city", label: "City", option: allCity },
        { value: "state", label: "State", option: allState },
        { value: "country", label: "Country", option: country },
        { value: "lead_source_id", label: "Lead Source", option: lead_source }
      ];
    }
    if (selectedTab === "company") {
      return [
        { value: "company_name", label: "Company Name" },
        { value: "website", label: "Website" },
        { value: "industry", label: "Industry", option: industryOptions },
        { value: "business_type", label: "Business Type", option: businessTypeOptions },
        { value: "employee_size", label: "Employee Size", option: employeeSizeOptions },
        { value: "owner_id", label: "Owner", option: leadOwner },
        { value: "email", label: "Email" },
        { value: "city", label: "City", option: allCity },
        { value: "state", label: "State", option: allState }
      ];
    }
    return [
      { value: "first_name", label: "First Name" },
      { value: "last_name", label: "Last Name" },
      { value: "email", label: "Email" },
      { value: "phone", label: "Phone" },
      { value: "pipeline_stage_id", label: "Pipeline Stage", option: pipelineStages },
      { value: "owner_id", label: "Owner", option: leadOwner },
      { value: "company_id", label: "Company Name", option: company },
      { value: "city", label: "City", option: allCity },
      { value: "state", label: "State", option: allState },
      { value: "country", label: "Country", option: country },
      { value: "lead_source_id", label: "Lead Source", option: lead_source },
      { value: "status", label: "Status" }
    ];
  }, [
    selectedTab,
    leadOwner,
    lead_source,
    company,
    contacts,
    country,
    allState,
    allCity,
    pipelineStages,
  ]);

  const subFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "contains", label: "Contains" },
    { value: "is_empty", label: "Is Empty" }
  ];

  const customSubFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" }
  ];

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    resolver: zodResolver(emailSchema),
    defaultValues: { body: "" },
  });

  const handleListData = async (id, options = {}) => {
    const cardId = id ?? activeCardId;
    if (!cardId) return;
    if (selectedTab === "leads" && !selectedPipelineId) return;

    let endpoint;
    if (selectedTab === "leads") {
      endpoint = `lead/fetchLeads/${customerId}/${selectedPipelineId}/${loginUserId}/${userType}/list/${cardId}`;
    } else if (selectedTab === "contact") {
      endpoint = `contacts/fetchAllContacts/${loginUserId}/${customerId}/${userType}/${cardId}`;
    } else if (selectedTab === "company") {
      endpoint = `company/fetchAllCompanies/${customerId}/${loginUserId}/${cardId}`;
    }

    if (!endpoint) return;

    const offset = options.offset ?? listOffset;
    const limit = options.limit ?? listLimit;

    try {
      setListLoading(true);
      const res = await GetRequest(
        endpoint,
        { headers, params: { limit, offset, search: "" } },
        extras
      );
      if (res?.status === "fail" || res?.success === false) {
        toast.error(res?.message || "Failed to load segment records");
        setListTableData([]);
        setListTotalCount(0);
        return;
      }
      setListTableData(res?.data || []);
      setListTotalCount(res?.total_count ?? res?.data?.length ?? 0);

      const filterValuesRaw = res?.filter_data?.[0]?.filter_values;
      if (filterValuesRaw) {
        try {
          const parsed =
            typeof filterValuesRaw === "string"
              ? JSON.parse(filterValuesRaw)
              : filterValuesRaw;
          setParsedFilterData(parsed);
        } catch {
          setParsedFilterData(null);
        }
      }
    } catch (e) {
      console.error(e);
      toast.error("Failed to load segment records");
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTab === "leads") {
      setCurrModule("leads");
      setCurrFilterEndpoint("common/filterQuery");
      setCurrFilterApplyQuery("lead/applyFilter");
    } else if (selectedTab === "company") {
      setCurrFilterEndpoint("company/filterQuery");
      setCurrFilterApplyQuery("company/applyFilter");
      setCurrModule("company");
    } else if (selectedTab === "contact") {
      setCurrFilterEndpoint("contacts/filterQuery");
      setCurrFilterApplyQuery("contacts/applyFilter");
      setCurrModule("contacts");
    }
    setFilterCardOffset(0);
    setListOffset(0);
    setCurrAdvFilter(null);
    setTempFilterData(null);
  }, [selectedTab]);

  useEffect(() => {
    if (!parsedFilterData || dropdownOptions.length === 0) return;
    try {
      const filteredArray = parsedFilterData.map((state) => {
        const dropdownOption = dropdownOptions.find(
          (opt) => opt.value === state.label_name
        );
        return {
          id: state.label_name,
          field: state.label_name,
          label_name: dropdownOption ? dropdownOption.label : state.label_name,
          subFilterType: state.label_query,
          value: state.label_value,
          // Options are already { value, label } from useCommonData / location / stages
          option: dropdownOption?.option ?? null,
        };
      });
      setFilterState(filteredArray);
    } catch (e) {
      console.error(e);
      setFilterState([]);
    }
  }, [parsedFilterData, dropdownOptions]);

  const fetchPipelines = async () => {
    try {
      const res = await GetRequest(`lead/fetchPipelines/${customerId}/leads/${customer?.customer_details?.id}/${customer.customer_details?.user_type}`, { headers }, extras);
      if (res.status === "fail" || res.success === false) {
        setSelectedPipelineId(null);
        setPipelines(null);
        return;
      }
      setPipelines(res.data);
      if (res?.data) {
        const selectpipe = res.data?.find((el) => el.is_active === "yes") || res?.data[0];
        setSelectedPipelineId(selectpipe.id);
      }
    } catch (error) {
      return;
    }
  };

  const fetchPipelineStage = async () => {
    try {
      const res = await GetRequest(`lead/fetchPipelineStage/${selectedPipelineId}/${customerId}/${customer?.customer_details?.id}`, { headers }, extras);
      if (res.status === 'fail' || res.success === false) {
        setPipelineStages(null);
        return;
      }
      const filterDropdownData = res.data && res.data.map((c) => ({
        value: c.id,
        label: c.stage_name,
      }));
      setPipelineStages(filterDropdownData);
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    if (selectedTab !== "leads") return;
    fetchPipelines();
  }, [selectedTab]);

  useEffect(() => {
    if (selectedTab !== "leads" || !selectedPipelineId) return;
    fetchPipelineStage();
  }, [selectedTab, selectedPipelineId]);

  const fetchAllStatesData = async () => {
    try {
      const data = await getAllStates();
      if (!data) {
        setAllState([]);
        return;
      }
      setAllState(
        data.map((state) => ({
          label: state.state_name,
          value: state.id,
        }))
      );
    } catch (error) {
      toast.error("Error Fetching State");
    }
  };

  const fetchAllCitiesData = async () => {
    try {
      const data = await getAllCities();
      if (!data) {
        setAllCity([]);
        return;
      }
      setAllCity(
        data.map((city) => ({
          label: city.city_name,
          value: city.id,
        }))
      );
    } catch (error) {
      toast.error("Error Fetching City");
    }
  };

  const fetchCountriesData = async () => {
    try {
      const data = await getCountries();
      if (!data) return;
      setCountries(
        data.map((country) => ({
          label: country.name,
          value: country.id,
        }))
      );
    } catch (error) {
      toast.error("Error Fetching Country");
    }
  };

  const initData = async () => {
    await Promise.all([
      fetchCountriesData(),
      fetchAllStatesData(),
      fetchAllCitiesData(),
    ]);
  };

  useEffect(() => {
    initData();
  }, []);

  const fetchTabData = async () => {
    const endpoint = getFilterCardsEndpoint(selectedTab);
    if (!endpoint || !customerId || !loginUserId) return;
    if (selectedTab === "leads" && !selectedPipelineId) return;

    try {
      setLoading(true);
      const res = await GetRequest(endpoint, { headers }, extras);
      if (res.success === false) {
        setTabData([]);
        setActiveCardId(null);
        setFilterPageCount(0);
        toast.error(res.message);
        return;
      }
      if (res.status === "fail") {
        setTabData([]);
        setActiveCardId(null);
        setFilterPageCount(0);
        return;
      }
      const cards = res?.data || [];
      setTabData(cards);
      if (res.total_count) {
        setFilterPageCount(Math.ceil(res.total_count / FILTER_CARD_LIMIT));
      } else {
        setFilterPageCount(cards.length >= FILTER_CARD_LIMIT ? filterCardOffset + 2 : filterCardOffset + 1);
      }
      if (cards.length > 0) {
        const stillActive = cards.some((c) => c.id === activeCardId);
        if (!stillActive) {
          setActiveCardId(cards[0].id);
          setListOffset(0);
        }
      } else {
        setActiveCardId(null);
        setListTableData([]);
        setListTotalCount(0);
        setParsedFilterData(null);
        setFilterState([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTabData();
  }, [selectedTab, refetchTabData, filterCardOffset, selectedPipelineId]);

  useEffect(() => {
    if (currAdvFilter === "apply") return;
    if (!activeCardId) return;
    if (selectedTab === "leads" && !selectedPipelineId) return;
    handleListData(activeCardId);
  }, [activeCardId, listOffset, listLimit, selectedPipelineId, currAdvFilter]);

  const handleFilterCardPageChange = (newOffset) => {
    setFilterCardOffset(newOffset.selected);
  };

  const handleListPageChange = (newOffset) => {
    setListOffset(newOffset.selected);
  };

  const listPageCount = Math.max(1, Math.ceil(activeListTotalCount / listLimit) || 1);

  const editCampaignName = async () => {
    if (!campaignName?.trim() || !updateCampaignId) return;
    const payload = {
      customer_id: customerId,
      user_login_id: loginUserId,
      filter_id: updateCampaignId,
      card_name: campaignName.trim(),
      description: description || "",
      module_name: getFilterRenameModuleName(selectedTab),
    };
    try {
      const res = await PutRequest("common/updateFilterName", payload, { headers }, extras);
      if (res?.status === "fail" || res?.success === false) {
        toast.error(res?.message || "Error updating filter");
        return;
      }
      toast.success(res?.message || "Campaign target parameter modified");
      await fetchTabData();
      setShowModal(false);
    } catch (error) {
      console.error(error);
      toast.error("Error updating filter");
    }
  };

  const deleteItemById = async () => {
    if (!deleteItemId) return;
    const deleteEndpoint = getDeleteFilterEndpoint(selectedTab, deleteItemId);
    if (!deleteEndpoint) return;
    setIsLoading(true);
    try {
      const res = await DeleteRequest(deleteEndpoint, { headers }, extras);
      if (res?.status === "fail" || res?.success === false) {
        toast.error(res?.message || "Failed to eliminate list segment");
        return;
      }
      toast.success(res?.message || "Target list purged successfully");
      setRefetchTabData((prev) => !prev);
    } catch (err) {
      toast.error("Failed to eliminate list segment");
    } finally {
      setShowDeleteModal(false);
      setDeleteItemId(null);
      setFilterDropdown(false);
      setTempFilterData(null);
      setIsLoading(false);
      setFilterState([]);
      setParsedFilterData(null);
    }
  };

  useEffect(() => { register("body", { required: "Template content body is required" }); }, [register]);

  const on = async (data) => {
    if (!emailCampaignGrant.isCreate) {
      toast.warning("You are not authorized for this action!");
      return;
    }
    if (!dataToDisplay || dataToDisplay.length === 0) {
      return toast.error("The selected target group contains 0 records");
    }

    const filterQueryForSend = isApplyFilterActive
      ? emailCampaignFilterValues?.filter_values
      : parsedFilterData;

    const payload = {
      filter_query: filterQueryForSend,
      customer_id: customerId,
      subject: data.subject,
      body: data.body,
      campaign_name: data.module_name,
      module_name: selectedTab,
      user_login_id: customer.customer_details.id,
      email_document: data.image?.[0] || "",
    };

    try {
      setButtonLoading(true);
      const res = await PostRequest(`${baseURL}Campaiging/sendMail`, payload, true, { headers }, extras);
      if (res.status === "success") {
        toast.success("Campaign sequence dispatched successfully");
      } else {
        toast.error("Failed during system pipeline delivery");
      }
    } catch (e) {
      toast.error("Error routing outgoing mail requests");
    } finally {
      setButtonLoading(false);
    }
  };

  if (!emailCampaignGrant?.isView) {
    return (
      <div className="container-fluid py-4 bg-light min-vh-100">
        <AuthorizationCard />
      </div>
    );
  }

  return (
    <div className="container-fluid py-4 px-lg-5 bg-slate-50 min-vh-100" style={{ backgroundColor: "#f8fafc" }}>
      <div className="row g-4">
        <div className="col-12">
          <div className="d-flex align-items-center justify-content-between bg-white p-4 rounded-4 shadow-2xs border border-slate-100">
            <div className="d-flex align-items-center gap-3">
              <div className="p-3 bg-primary-subtle text-primary rounded-3 d-flex align-items-center justify-content-center" style={{ width: "50px", height: "50px" }}>
                <FontAwesomeIcon icon={faEnvelope} className="fs-4" />
              </div>
              <div>
                <h4 className="mb-1 text-dark fw-bold">Email Campaigns </h4>
                <p className="mb-0 text-muted small">Design tailored outreach sequences, configure precise target segments, and dispatch broadcasts.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Left Hand Canvas: Segments & Data Grid (7 Cols) */}
        <div className="col-xl-7 d-flex flex-column gap-2 mt-2">

          {/* Section 1: Audience Selection Hub */}
          <div className="card shadow-2xs border border-slate-100 p-4 bg-white rounded-4">
            <div className="d-flex align-items-center justify-content-between pb-3 border-bottom border-slate-100 mb-3">
              <div className="d-flex align-items-center gap-2">
                <FontAwesomeIcon icon={faLayerGroup} className="text-primary" />
                <span className="fw-bold text-dark">Target Segment Engine</span>
              </div>

              {/* Module Selector Pill Tabs */}
              <div className="bg-slate-100 p-1 rounded-3 d-flex gap-1" style={{ backgroundColor: "#f1f5f9" }}>
                {["leads", "company", "contact"].map((tab) => (
                  <button
                    key={tab}
                    type="button"
                    className={`btn btn-sm px-3 py-1 text-capitalize fw-semibold rounded-2 transition-all border-0 ${selectedTab === tab ? "bg-white text-primary shadow-2xs" : "text-secondary bg-transparent"}`}
                    onClick={() => {
                      setFilterDropdown(false);
                      setSelectedTab(tab);
                      setFilterState([]);
                      setParsedFilterData(null);
                      setListTableData([]);
                      setActiveCardId(null);
                      setFilterCardOffset(0);
                      setListOffset(0);
                      setCurrAdvFilter(null);
                      setTempFilterData(null);
                    }}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>

            {/* Sub-Filters / Pipelines Row */}
            <div className="d-flex align-items-center justify-content-end flex-wrap gap-3 mb-3">
              <div className="" style={{ minWidth: "200px" }}>
                {selectedTab === "leads" && pipeline && (
                  <Select
                    options={pipelineOptions}
                    value={pipelineOptions && pipelineOptions?.find(option => option.value === selectedPipelineId)}
                    onChange={(selectedOption) => {
                      setSelectedPipelineId(selectedOption.value);
                      setListOffset(0);
                      setFilterCardOffset(0);
                      setActiveCardId(null);
                      setCurrAdvFilter(null);
                      setTempFilterData(null);
                    }}
                    styles={{
                      ...customStyles,
                      control: (base) => ({
                        ...base,
                        height: "38px",
                        borderRadius: "10px",
                        borderColor: "#e2e8f0",
                        boxShadow: "none",
                        backgroundColor: "#f8fafc",
                        "&:hover": { borderColor: "#cbd5e1" }
                      }),
                      singleValue: (base) => ({ ...base, fontSize: "0.85rem", fontWeight: 600, color: "#334155", marginLeft: "10px" }),
                      option: (base) => ({ ...base, fontSize: "0.85rem" }),
                    }}
                    isSearchable={true}
                    placeholder="Filter by Pipeline..."
                  />
                )}
              </div>

              <Filter
                canEdit_canDownload={true}
                filterDropdown={filterDropdown}
                setFilterDropdown={setFilterDropdown}
                dropdownOptions={dropdownOptions}
                filterState={filterStates}
                setFilterState={setFilterState}
                subFilter={subFilter}
                customSubFilter={customSubFilter}
                module_name={currModule}
                setTempFilterData={setTempFilterData}
                setCurrAdvFilter={setCurrAdvFilter}
                filterEndpoint={currFilterEndpoint}
                applyQuery={currFilterApplyQuery}
                filterQueryKey={EMAIL_CAMPAIGN_FILTER_QUERY_KEY}
                view="list"
                pipelineId={selectedPipelineId}
                setOffset={setListOffset}
                setHeading={() => setRefetchTabData((prev) => !prev)}
              />
            </div>

            {/* Segment Cards Track */}
            {loading ? (
              <div className="text-center py-4 text-secondary small">
                <div className="spinner-border spinner-border-sm me-2 text-primary" /> Loading Segment Tokens...
              </div>
            ) : tabData?.length > 0 ? (
              <div className="d-flex flex-column gap-3">
                <div className="d-flex gap-2 align-items-center flex-wrap custom-horizontal-scrollbar py-1">
                  {tabData.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => {
                        setCurrAdvFilter(null);
                        setTempFilterData(null);
                        setListOffset(0);
                        setActiveCardId(item.id);
                      }}
                      className={`d-flex align-items-center justify-content-between p-2.5 border rounded-3 transition-all`}
                      style={{
                        minWidth: "190px",
                        maxWidth: "230px",
                        cursor: "pointer",
                        backgroundColor: activeCardId === item.id ? "#eff6ff" : "#ffffff",
                        borderColor: activeCardId === item.id ? "#3b82f6" : "#e2e8f0",
                      }}
                    >
                      <span className={`text-truncate fw-semibold px-1 small ${activeCardId === item.id ? "text-primary" : "text-dark"}`}>
                        {item.card_name}
                      </span>

                      <Dropdown onClick={(e) => e.stopPropagation()} align="end">
                        <Dropdown.Toggle as="button" className="btn btn-link p-1 text-muted no-arrow shadow-none border-0">
                          <FontAwesomeIcon icon={faEllipsisVertical} size="sm" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="shadow-sm border-0 py-1" style={{ fontSize: "13px" }}>
                          <Dropdown.Item onClick={() => {
                            setCurrAdvFilter(null);
                            setTempFilterData(null);
                            setListOffset(0);
                            setActiveCardId(item.id);
                          }}>
                            <FontAwesomeIcon icon={faEye} className="me-2 text-muted" /> View Group
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => {
                            if (!emailCampaignGrant.isEdit) {
                              toast.warning("You are not authorized for this action!");
                              return;
                            }
                            setCampaignName(item.card_name);
                            setUpdateCampaignId(item.id);
                            setDescription(item.description);
                            setShowModal(true);
                          }}>
                            <FontAwesomeIcon icon={faEdit} className="me-2 text-muted" /> Edit Label
                          </Dropdown.Item>
                          <Dropdown.Divider />
                          <Dropdown.Item className="text-danger" onClick={() => {
                            if (!emailCampaignGrant?.isDelete) {
                              toast.warning("You are not authorized for this action!");
                              return;
                            }
                            setDeleteItemId(item.id);
                            setShowDeleteModal(true);
                          }}>
                            <FontAwesomeIcon icon={faTrash} className="me-2" /> Delete Segment
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  ))}
                </div>
                {filterPageCount > 1 && (
                  <Pagination
                    offset={filterCardOffset}
                    setOffset={setFilterCardOffset}
                    handlePageChange={handleFilterCardPageChange}
                    pageCount={filterPageCount}
                  />
                )}
              </div>
            ) : (
              <div className="text-center py-4 text-muted border border-dashed rounded-3 small bg-slate-50">
                No targeted query modules verified. Configure filter parameters to establish tracking segments.
              </div>
            )}
          </div>

          {/* Section 2: Population Matrix Table View */}
          <div className="card shadow-2xs border border-slate-100 p-4 bg-white rounded-4 flex-grow-1">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3 pb-2 border-bottom border-slate-100">
              <span className="fw-bold text-dark">Segment Population Matrix</span>

              {/* Rows Per Page Dropdown Placed on Top Right Corner */}
              <div className="d-flex align-items-center gap-2">
                <span className="text-muted small">Rows per page</span>
                <Dropdown align="end" className="position-relative">
                  <Dropdown.Toggle className="btn btn-outline-light text-dark border border-slate-200 no-arrow btn-sm px-2.5 py-1 rounded-2 shadow-2xs bg-white" style={{ display: "flex", alignItems: "center", gap: "6px", }}>
                    {listLimit}
                    <i className="bx bx-chevron-down text-slate-500" style={{ fontSize: "16px" }} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end" className="shadow-sm border-0 mt-1" style={{ minWidth: "3rem", textAlign: "center", zIndex: 1050 }}>
                    {LIST_LIMIT_OPTIONS.map((el) => (
                      <Dropdown.Item
                        key={el}
                        onClick={() => {
                          setListLimit(el);
                          setListOffset(0);
                        }}
                      >
                        {el}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>

            {(listLoading || tempFilterDataLoading) && (
              <div className="text-center py-3 text-secondary small">
                <div className="spinner-border spinner-border-sm me-2 text-primary" /> Loading records...
              </div>
            )}

            <div className="table-responsive border border-slate-100 rounded-3 position-relative" style={{ maxHeight: "380px" }}>
              <Table hover striped size="sm" className="mb-0 align-middle text-nowrap" style={{ fontSize: "13px" }}>
                <thead className="bg-slate-50 text-slate-600 border-bottom border-slate-100" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                  <tr>
                    <th className="py-2.5 px-3 fw-semibold">#</th>
                    <th className="fw-semibold">Name</th>
                    <th className="fw-semibold">Email</th>
                    <th className="fw-semibold">Phone Number</th>
                    {selectedTab === "contact" && (
                      <>
                        <th className="fw-semibold">Lead Source</th>
                        <th className="fw-semibold">Lead Owner</th>
                      </>
                    )}
                    {selectedTab === "company" && <th className="fw-semibold">Rating System</th>}
                    {selectedTab === "leads" && (
                      <>
                        <th className="fw-semibold">Status Flag</th>
                        <th className="fw-semibold">Lead Owner</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody className="text-slate-600 border-0">
                  {dataToDisplay?.length > 0 ? (
                    dataToDisplay.map((item, i) => {
                      const phoneNumber = selectedTab === "leads" ? JSON.parse(item.contact_phone) : item.phone;
                      console.log('phoneNumber', phoneNumber !== null ? phoneNumber?.[0].phone : "-")
                      return (
                        <tr key={item.id || i}>
                          <td className="py-2.5 px-3 fw-medium text-dark">{listOffset + i + 1}</td>
                          <td className="fw-semibold text-slate-900" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '150px' }}>{item.first_name || item.company_name || "N/A"}</td>
                          <td>{selectedTab === "leads" ? item.contact_email : item.email || "—"}</td>
                          <td>{selectedTab === "leads" ? phoneNumber !== null ? phoneNumber?.[0].phone : "-" : item.phone || "—"}</td>
                          {selectedTab === "contact" && (
                            <>
                              <td><span className="badge  border" style={{ background: '#f1f5f9', color: '#065f46' }}>{item.source_title || "Organic"}</span></td>
                              <td>{item.owner_name || "—"}</td>
                            </>
                          )}
                          {selectedTab === "company" && (
                            <td className="fw-bold text-amber-500">★ {item.rating || "0.0"}</td>
                          )}
                          {selectedTab === "leads" && (
                            <>
                              <td>
                                <span className={`badge px-2 py-1`} style={{ backgroundColor: item.lead_status?.toLowerCase() === 'unqualified' ? '#f1f5f9' : '#d1e8ff', color: item.lead_status?.toLowerCase() === 'unqualified' ? '#065f46' : '#0984e3' }}>
                                  {item.lead_status || "Unassigned"}
                                </span>
                              </td>
                              <td>{selectedTab === 'leads' ? item?.lead_owner_name : item.owner_name || "—"}</td>
                            </>
                          )}
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td className="text-center py-4 text-muted small" colSpan={100}>
                        No production records matched against the target search profile matrix.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {/* Custom Table Footer: Showing Items on Extreme Left & Pagination on Extreme Right */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 pt-3 mt-2 border-top border-slate-100">
              <span className="text-muted small fw-medium">
                Showing <strong className="text-dark">{startItemIndex}-{endItemIndex}</strong> of <strong className="text-dark">{activeListTotalCount}</strong> items
              </span>

              {activeListTotalCount > listLimit && (
                <div>
                  <Pagination
                    offset={listOffset}
                    setOffset={setListOffset}
                    handlePageChange={handleListPageChange}
                    pageCount={listPageCount}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Right Hand Canvas: Outreach Composer Sticky Panel (5 Cols) */}
        <div className="col-xl-5">
          <div className="card shadow-2xs border border-slate-100 p-4 bg-white rounded-4 sticky-top" style={{ top: "24px", zIndex: 9 }}>
            <div className="d-flex align-items-center gap-2 pb-3 border-bottom border-slate-100 mb-4">
              <FontAwesomeIcon icon={faPaperPlane} className="text-primary" />
              <span className="fw-bold text-dark fs-6">Outreach Sequence Composer</span>
            </div>

            <Form onSubmit={handleSubmit(on)} className="d-flex flex-column gap-3">
              <Form.Group>
                <Form.Label className="fw-semibold text-slate-700 small mb-1">Campaign Label <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  size="sm"
                  isInvalid={!!errors.module_name}
                  placeholder="e.g., Q2 Retargeting Cycle"
                  className="rounded-3 shadow-none border-slate-200 py-2"
                  {...register("module_name")}
                />
                {errors.module_name && <Form.Control.Feedback type="invalid">{errors.module_name.message}</Form.Control.Feedback>}
              </Form.Group>

              <Form.Group>
                <Form.Label className="fw-semibold text-slate-700 small mb-1">Subject Header <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  size="sm"
                  isInvalid={!!errors.subject}
                  placeholder="Enter broadcast mail subject header"
                  className="rounded-3 shadow-none border-slate-200 py-2"
                  {...register("subject")}
                />
                {errors.subject && <Form.Control.Feedback type="invalid">{errors.subject.message}</Form.Control.Feedback>}
              </Form.Group>

              <Form.Group>
                <Form.Label className="fw-semibold text-slate-700 small mb-1">Rich Text Email Body <span className="text-danger">*</span></Form.Label>
                <div className={`p-1 border rounded-3 bg-slate-50 ${errors.body ? 'border-danger' : 'border-slate-200'}`}>
                  <Controller
                    name="body"
                    control={control}
                    render={({ field }) => (
                      <MyEditor
                        initialData={field.value}
                        onDataChange={(data) => field.onChange(data)}
                      />
                    )}
                  />
                </div>
                {errors.body && <div className="text-danger mt-1" style={{ fontSize: "11px" }}>{errors.body.message}</div>}
              </Form.Group>

              <Form.Group>
                <Form.Label className="fw-semibold text-slate-700 small mb-1">File Attachment Layer</Form.Label>
                <Form.Control
                  type="file"
                  size="sm"
                  className="rounded-3 shadow-none border-slate-200 py-2"
                  {...register("image")}
                />
              </Form.Group>

              <Button
                type="submit"
                disabled={buttonLoading}
                variant="primary"
                className="w-100 fw-bold py-2.5 mt-3 shadow-xs rounded-3"
                style={{ fontSize: "14px" }}
              >
                {buttonLoading ? (
                  <span className="d-flex align-items-center justify-content-center gap-2">
                    <span className="spinner-border spinner-border-sm" /> Dispensing Sequences...
                  </span>
                ) : (
                  <span>Dispatch Campaign Pipeline</span>
                )}
              </Button>
            </Form>
          </div>
        </div>
      </div>

      {/* Persistent System Modals Handling Context */}
      {showDeleteModal && (
        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={deleteItemById}
          isLoading={isLoading}
          message="Are you certain you want to permanently strip out this selection target parameter rule set?"
        />
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered className="border-0">
        <Modal.Header closeButton className="pb-2 border-0">
          <Modal.Title className="fw-bold text-dark fs-6">Modify Parameter Label</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-2">
          <Form.Group>
            <Form.Label className="text-muted small mb-1">Target Segment Title Name <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Input updated label tag"
              value={campaignName}
              onChange={(e) => setCampaignName(e.target.value)}
              className="rounded-3 shadow-none border-slate-200 py-2"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="pt-2 border-0">
          <Button variant="light" className="fw-semibold px-3 border rounded-3" onClick={() => setShowModal(false)}>
            Dismiss
          </Button>
          <Button variant="primary" className="fw-bold px-4 rounded-3" onClick={editCampaignName}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Native Micro-Layout Overrides */}
      <style>{`
        .custom-horizontal-scrollbar::-webkit-scrollbar { height: 4px; }
        .custom-horizontal-scrollbar::-webkit-scrollbar-thumb { background-color: #cbd5e1; border-radius: 4px; }
        .no-arrow::after { display: none !important; }
        .table-responsive::-webkit-scrollbar { width: 4px; height: 4px; }
        .table-responsive::-webkit-scrollbar-thumb { background-color: #cbd5e1; border-radius: 4px; }
      `}</style>
    </div>
  );
};